import Vue from 'vue'
import VueI18n from 'vue-i18n'
//import elementEnLocale from 'element-ui/lib/locale/lang/en'
//import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN'
import locale from 'element-ui/lib/locale' // 引入elementui语言包模块
//import enLocale from './en.js' // 本地英文包
//import zhLocale from './zh.js' // 本地中文包
import messages from "./messages"

Vue.use(VueI18n) // vue使用i18n模块

// const messages = {
//   en: {
//     ...enLocale,
//     ...elementEnLocale
//   },
//   zh: {
//     ...zhLocale,
//     ...elementZhLocale
//   }
// }
// 使用选项创建VueI18n实例

const i18n = new VueI18n({
  locale: localStorage.getItem('lang') || 'zh', 
  fallbackLocale:'zh', //首选语言缺少翻译时要使用的语言，
  messages ,// 设置语言环境信息
  silentTranslationWarn: true,//去掉页面警告
})


locale.i18n((key, value) => i18n.t(key, value)) // 在注册Element时设置i18n的处理方法
export default i18n
